<template>
    <section class="bg-white dark:bg-gray-900  h-[750px] overflow-x-hidden overflow-y-scroll">
        <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
            <!-- Ownership Information -->
            <div class="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                <h2 class="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">Ownership</h2>
                <p class="mb-4 font-light">
                    This project is developed and maintained by the PubMatcher team, affiliated with Bordeaux
                    University Hospital, France.
                </p>
                <p class="mb-4 font-medium">
                    For inquiries, contact us at <a href="mailto:admin@pubmatcher.com"
                        class="text-blue-500 underline">admin@pubmatcher.fr</a>.
                </p>
            </div>
            <hr class="my-4 border-t border-gray-150" />

            <!-- Hosting Provider -->
            <div class="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                <h2 class="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">Hosting</h2>
                <p class="mb-4 font-light">
                    This website is hosted by OVH, located at 2 Rue Kellermann, 59100 Roubaix, France. For more
                    information, visit their website at <a href="https://www.ovh.com" target="_blank"
                        rel="noopener noreferrer" class="text-blue-500 underline">www.ovh.com</a>.
                </p>
            </div>
            <hr class="my-4 border-t border-gray-150" />

            <!-- Intellectual Property -->
            <div class="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                <h2 class="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">Intellectual Property
                </h2>
                <p class="mb-4 font-light">
                    All content, logos, and software provided by PubMatcher are protected under copyright laws.
                    Unauthorized reproduction, modification, or distribution is strictly prohibited unless explicitly
                    authorized under the applicable license.
                </p>
                <p class="mb-4 font-medium">
                    This project is distributed under the MIT License. For details, visit the <a
                        href="https://opensource.org/licenses/MIT" target="_blank" rel="noopener noreferrer"
                        class="text-blue-500 underline">MIT License website</a>.
                </p>
            </div>

            <hr class="my-4 border-t border-gray-150" />

            <!-- Data Handling -->
            <div class="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                <h2 class="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">Data Handling</h2>
                <p class="mb-4 font-light">
                    This tool collects minimal personal data required for account creation and usage tracking, as
                    detailed in our <a href="/privacy-policy" class="text-blue-500 underline">Privacy Policy</a>.
                </p>
                <p class="mb-4 font-medium">
                    Data processing complies with GDPR (General Data Protection Regulation) requirements for users
                    located in the European Union.
                </p>
            </div>
            <hr class="my-4 border-t border-gray-150" />

            <!-- Jurisdiction -->
            <div class="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                <h2 class="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">Jurisdiction</h2>
                <p class="mb-4 font-light">
                    These legal mentions are governed by the laws of France. Any disputes arising from the use of this
                    website or its services shall fall under the exclusive jurisdiction of the courts of Bordeaux,
                    France.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'LegalMentionsPage',
};
</script>